import { extend } from "vee-validate"
import {
    required,
    email,
    confirmed,
    double,
    max_value,
    min_value,
    min,
    is_not,
    regex,
} from "vee-validate/dist/rules"

extend("required", required)
extend("email", email)
extend("confirmed", confirmed)
extend("double", double)
extend("max_value", max_value)
extend("min_value", min_value)
extend("min", min)
extend("is_not", is_not)
extend("regex", regex)
